// Warteschlange für fertige Runs: übersteht Netzausfälle und Neuladen der Seite.
const KEY = "klimawerk-outbox"

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]")
  } catch {
    return []
  }
}

function write(items) {
  try {
    localStorage.setItem(KEY, JSON.stringify(items))
  } catch {
    // Speicher voll oder gesperrt: dann bleibt nur der QR-Fallback.
  }
}

export class Outbox {
  constructor(url) {
    this.url = url
    this.synced = new Set()
    this.flushing = null
    setInterval(() => this.flush(), 15000)
    window.addEventListener("online", () => this.flush())
  }

  push(payload) {
    write([...read().filter((item) => item.token !== payload.token), payload])
    return this.flush()
  }

  isSynced(token) {
    return this.synced.has(token)
  }

  pending() {
    return read().length
  }

  flush() {
    if (this.flushing) return this.flushing
    this.flushing = (async () => {
      for (const payload of read()) {
        try {
          const response = await fetch(this.url, {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ run: payload })
          })
          if (response.ok || response.status === 422) {
            if (response.ok) this.synced.add(payload.token)
            else console.warn("Run abgelehnt", payload.token, await response.text())
            write(read().filter((item) => item.token !== payload.token))
          }
        } catch {
          break
        }
      }
    })().finally(() => (this.flushing = null))
    return this.flushing
  }
}

export function newToken() {
  const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789"
  const bytes = crypto.getRandomValues(new Uint8Array(24))
  return Array.from(bytes, (b) => alphabet[b % alphabet.length]).join("")
}
